import { Moment } from 'moment'

import { BaseModel } from './base.model'
import { Center } from './center.model'
import { Program } from './program.model'
import { SessionExamResult } from './session.model'
import { Interview, InterviewResult } from './interview.model'
import { User } from './user.model'
import { Comment } from './comment.model'
import { ExamRegistration } from './exam-registration.model'
import { CenterProgram } from './center-program.model'
import { BriefingRegistration } from './briefing-registration.model'
import { Briefing } from './briefing.model'

/**
 * Количество попыток записи, включает в себя текущее и максимально допустимое значения
 */
export interface RecordingAttempts {
  max: number 
  current: number
}
export class OnlineSession extends BaseModel<OnlineSession> {
  static DEFAULT_ATTRIBUTES = {}
  
  uuid: string
  firstName: string
  lastName: string
  middleName: string
  phoneNumber: string
  licenseNumber: string
  state: string
  programId: number
  centerId: number
  passed: boolean
  grade: number
  interviewerId: number
  completedAt: Moment
  canceledAt: Moment
  createdAt: Moment
  updatedAt: Moment
  examStartedAt: Moment
  examCompletedAt: Moment
  scheduledAt: Moment
  interviewer: User
  cityName: string

  center: Center
  program: Program
  examResults: SessionExamResult[]
  interview: Interview
  interviewResult: InterviewResult
  onlineInterviewerComments: Comment[]
  interviewAttempts: RecordingAttempts
  interviewRegistration: ExamRegistration
  interviewState: string
  centerProgram: CenterProgram
  locale: string
  attachments: any[]
  briefingRegistration: BriefingRegistration
  briefing: Briefing
  briefingAttempts: RecordingAttempts

  meta: {
    hubModeration?: boolean
    unlockBase?: boolean
  }

  progress: Object


  get waitingForInterview(): boolean {
    return this.state == "waiting_interview"
  }

  get interviewInProcess(): boolean {
    return this.state == "interview"
  }

  get isCompleted(): boolean {
    return this.state == "completed"
  }

  get isCancelled(): boolean {
    return this.state == "canceled"
  }
  
  /**
   * статус == completed или canceled
   */
  get isFinished(): boolean {
    return this.isCompleted || this.isCancelled
  }

  get interviewMovable(): boolean {
    return this.waitingForInterview || this.interviewInProcess
  }

  get hasInterviewRegistration(): boolean {
    return !!this.interviewRegistration
  }

  get hasBriefingRegistration(): boolean {
    return this.briefingRegistration && this.briefingRegistration.state == 'active'
  }
  
  // Статусы интервью

  get interviewIsRejected(): boolean {
    return this.interviewState == "interview_rejected"
  }

  get interviewIsApproved(): boolean {
    return this.interviewState == "interview_approved"
  }

  get briefingScheduledAt(): string {
    if (this.briefingRegistration) {
      const cityUTCOffset = this.center && this.center.city && this.center.city.utcOffset
      return this.briefingRegistration.scheduledAt.utcOffset(cityUTCOffset).format("DD.MM.YYYY HH:mm")
    } 
    else {
      return "Нет записи"
    }
  }

  get briefingAddress(): string {
    if (this.briefingRegistration && this.briefingRegistration.briefing) {
      return this.briefingRegistration.briefing.address
    }
    else {
      return "Нет записи"
    }
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/online-session.model.ts